import type { LocationScopeOption } from './LocationScopeControl';

type LocationLike = {
  id?: number | null;
  name?: string | null;
  type?: string | null;
};

/**
 * Shared branch scope list for Orders / Sales-by-piece / inventory filters.
 * Keeps locations with missing `type` (legacy payloads) so menus stay populated.
 */
export function filterBranchLocations(
  locations: LocationLike[],
  branchType = 'BRANCH',
): LocationScopeOption[] {
  return locations
    .filter((loc) => !loc.type || loc.type === branchType)
    .filter(
      (loc): loc is LocationLike & { id: number; name: string } =>
        typeof loc.id === 'number' && typeof loc.name === 'string' && loc.name.length > 0,
    )
    .map((loc) => ({ id: loc.id, name: loc.name }));
}
